module.exports = __webpack_public_path__ + "static/media/22.af3d45e4.jpg";